import { isNullOrUndefined } from '@bimser/core';
import Icon from '@bimser/icons/16/date';
import { DatePicker } from 'antd-mobile';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import React, { useState } from 'react';
import { BCInput, BCInputRef, findMessage } from '../';
import { IBCMobileDateTimePickerProps } from './entities';
dayjs.extend(localizedFormat);

export default function BCMobileDateTimePicker(props: IBCMobileDateTimePickerProps) {
	const [visible, setVisible] = useState(false);
	const inputRef = React.useRef<BCInputRef>();

	React.useEffect(() => {
		if (inputRef.current) {
			inputRef.current.input.readOnly = true;
		}
	}, [inputRef.current]);

	function onConfirmValue(value: string | number | dayjs.Dayjs | Date) {
		const date = dayjs(value);
		if (date.isValid()) {
			const shortISODate = date.format().split('T')[0];
			const longISODate = date.format().split('+')[0];
			const dateTimeOffsetString = date.format();
			props?.onChange(
				date,
				dateTimeOffsetString,
				dateTimeOffsetString,
				shortISODate,
				longISODate,
				dateTimeOffsetString
			);
		} else {
			props?.onChange(null, null, null, null, null, null);
		}
	}

	function getPrecision() {
		if (['month', 'year'].includes(props.mode)) {
			return props.mode as 'month' | 'year';
		} else if (props.showTime || isNullOrUndefined(props.format)) {
			return 'minute';
		} else if (props.format.includes('ss')) {
			return 'second';
		} else if (props.format.includes('mm')) {
			return 'minute';
		} else if (props.format.includes('HH')) {
			return 'hour';
		}
		return 'day';
	}

	function onChangeVisible(pickerVisible: boolean) {
		setVisible(pickerVisible);
	}

	function formatValue() {
		if (props.mode === 'year') {
			return props.value?.format('YYYY') || '';
		} else if (props.mode === 'month') {
			return props.value?.format('MM.YYYY') || '';
		}

		return props.value?.format(props.format) || '';
	}

	function renderLabel(type: string, value: number) {
		switch (type) {
			case 'month': {
				return dayjs()
					.month(value - 1)
					.format('MMMM');
			}
			case 'hour': {
				return `${value} (${findMessage.get('100348').toLocaleLowerCase()})`;
			}
			case 'minute': {
				return `${value} (${findMessage.get('100349').toLocaleLowerCase()})`;
			}
			default: {
				return value;
			}
		}
	}

	return (
		<>
			<BCInput
				ref={inputRef}
				onClick={() => onChangeVisible(true)}
				onChange={args => onConfirmValue(args.data)}
				value={formatValue()}
				disabled={props.disabled || props.readOnly}
				placeHolder={props.placeholder}
				allowClear={props.allowClear}
				style={props.style}
				textAlign={props.textAlign}
				suffix={!props.value ? <Icon /> : ''}
			/>
			<DatePicker
				visible={visible}
				onClose={() => onChangeVisible(false)}
				precision={getPrecision()}
				onConfirm={onConfirmValue}
				renderLabel={renderLabel}
				confirmText={findMessage.get('100004')}
				cancelText={findMessage.get('100034')}
				min={props.disableBefore}
				max={props.disableAfter}
			/>
		</>
	);
}
